export enum KanbanCardFilterRange {
  ALL = "ALL",
  THIS_MONTH = "THIS_MONTH",
  NEXT_MONTH = "NEXT_MONTH",
}
